export const dealDocsLoadingSelector = (state) =>
  state.dealDocs.isLoadingDealDocuments;
export const dealDocsListSelector = (state) => state.dealDocs.dealDocumentsList;
export const dealDocsErrorSelector = (state) =>
  state.dealDocs.dealDocumentsError;
export const dealDocsSuccessSelector = (state) =>
  state.dealDocs.dealDocumentsSuccess;
